// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2666666667);
  display: flex;
  float: none;
  margin: 0;
  padding: 4px;
  opacity: var(--toolbar-opacity, 1);
}
:host.menubar-top {
  flex-direction: row;
  justify-content: flex-end;
}
:host.menubar-left {
  flex-direction: column;
  justify-content: flex-start;
}
:host.menubar-right {
  flex-direction: column;
  justify-content: flex-start;
}
:host.menubar-bottom {
  flex-direction: row;
  justify-content: flex-end;
}

.team-button {
  width: 38px !important;
  height: 38px !important;
  padding: 0 !important;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.08);
  transition: border-radius 0.15s ease, background 0.15s ease, color 0.15s ease;
  line-height: 38px;
  margin: 2px 0;
}
.team-button:hover {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}
.team-button.active {
  background: var(--team-button-active, #5b6eae);
  color: #fff;
}
.team-button.place-offline {
  opacity: 0.35;
  cursor: default;
}
.team-button.place-offline:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.6);
}
.team-button .mat-mdc-button-touch-target {
  width: 38px !important;
  height: 38px !important;
}
:host(.menubar-top) .team-button, :host(.menubar-bottom) .team-button {
  margin: 0 2px;
}

.team-separator {
  width: 24px;
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
  margin: 6px 0;
  flex-shrink: 0;
}
:host(.menubar-top) .team-separator, :host(.menubar-bottom) .team-separator {
  width: 1px;
  height: 24px;
  margin: 0 6px;
}

.menubar-logo {
  object-fit: contain;
  padding: 4px;
  height: 30px;
  width: auto;
}
:host(.menubar-left) .menubar-logo, :host(.menubar-right) .menubar-logo {
  height: auto;
  width: 24px;
  padding: 4px 0;
}

.command-palette-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 15vh;
}

.command-palette {
  width: min(580px, 92vw);
  max-height: 62vh;
  display: flex;
  flex-direction: column;
  --pal-bg: #ffffff;
  --pal-fg: rgba(0, 0, 0, 0.87);
  --pal-muted: rgba(0, 0, 0, 0.5);
  --pal-faint: rgba(0, 0, 0, 0.38);
  --pal-line: rgba(0, 0, 0, 0.12);
  --pal-hover: rgba(0, 0, 0, 0.06);
  --pal-active: #2e7d32;
  --pal-pinned: #f9a825;
  --pal-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);
  background: var(--pal-bg);
  color: var(--pal-fg);
  border: 1px solid var(--pal-line);
  border-radius: 12px;
  box-shadow: var(--pal-shadow);
  overflow: hidden;
}

.palette-search {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--pal-line);
}
.palette-search mat-icon {
  color: var(--pal-muted);
}
.palette-search input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: var(--pal-fg);
  font-size: 15px;
}
.palette-search input::placeholder {
  color: var(--pal-faint);
}

.palette-kbd {
  font-size: 11px;
  color: var(--pal-muted);
  border: 1px solid var(--pal-line);
  border-radius: 4px;
  padding: 1px 6px;
}

.palette-list {
  overflow-y: auto;
  padding: 4px 0 8px;
}

.palette-category {
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--pal-faint);
  padding: 10px 16px 3px;
}

.palette-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 7px 16px;
  cursor: pointer;
  color: var(--pal-fg);
}
.palette-row.selected {
  background: var(--pal-hover);
}
.palette-row .palette-icon {
  color: var(--pal-muted);
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.palette-row .palette-label {
  flex: 1;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.palette-row .palette-active {
  color: var(--pal-active);
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.palette-row .palette-pin {
  width: 30px !important;
  height: 30px !important;
  line-height: 30px !important;
  padding: 0 !important;
  opacity: 0.35;
}
.palette-row .palette-pin mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
}
.palette-row .palette-pin:hover {
  opacity: 0.8;
}
.palette-row .palette-pin.pinned {
  opacity: 1;
  color: var(--pal-pinned);
}

.palette-empty {
  padding: 18px 16px;
  color: var(--pal-muted);
  font-size: 14px;
}

:host-context(.dark) .command-palette {
  --pal-bg: #23252b;
  --pal-fg: rgba(255, 255, 255, 0.92);
  --pal-muted: rgba(255, 255, 255, 0.5);
  --pal-faint: rgba(255, 255, 255, 0.38);
  --pal-line: rgba(255, 255, 255, 0.1);
  --pal-hover: rgba(255, 255, 255, 0.1);
  --pal-active: #7bd88f;
  --pal-pinned: #ffd54f;
  --pal-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);
}`, "",{"version":3,"sources":["webpack://./src/app/components/menubar/menubar.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kCAAA;AACF;AACE;EACE,mBAAA;EACA,yBAAA;AACJ;AAEE;EACE,sBAAA;EACA,2BAAA;AAAJ;AAGE;EACE,sBAAA;EACA,2BAAA;AADJ;AAIE;EACE,mBAAA;EACA,yBAAA;AAFJ;;AAMA;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,qCAAA;EACA,6EAAA;EACA,iBAAA;EACA,aAAA;AAHF;AAKE;EACE,qCAAA;EACA,WAAA;AAHJ;AAME;EACE,8CAAA;EACA,WAAA;AAJJ;AAQE;EACE,aAAA;EACA,eAAA;AANJ;AAQI;EACE,qCAAA;EACA,+BAAA;AANN;AAUE;EACE,sBAAA;EACA,uBAAA;AARJ;AAYE;EAEE,aAAA;AAXJ;;AAeA;EAEE,WAAA;EACA,WAAA;EACA,qCAAA;EACA,aAAA;EACA,cAAA;AAbF;AAgBE;EAEE,UAAA;EACA,YAAA;EACA,aAAA;AAfJ;;AAmBA;EACE,mBAAA;EACA,YAAA;EAGA,YAAA;EACA,WAAA;AAlBF;AAoBE;EAGE,YAAA;EACA,WAAA;EACA,cAAA;AApBJ;;AA0BA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;AAvBF;;AA0BA;EACE,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EAGA,iBAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,+BAAA;EACA,gCAAA;EACA,qBAAA;EACA,qBAAA;EACA,6CAAA;EACA,yBAAA;EACA,oBAAA;EACA,iCAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,wCAAA;AAzBF;AA2BE;EACE,uBAAA;AAzBJ;AA4BE;EACE,OAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;AA1BJ;AA4BI;EACE,uBAAA;AA1BN;;AA+BA;EACE,eAAA;EACA,uBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,kBAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AA5BF;AA8BE;EACE,4BAAA;AA5BJ;AA+BE;EACE,uBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA7BJ;AAgCE;EACE,OAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA9BJ;AAiCE;EACE,wBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA/BJ;AAkCE;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;AAhCJ;AAkCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhCN;AAmCI;EACE,YAAA;AAjCN;AAoCI;EACE,UAAA;EACA,wBAAA;AAlCN;;AAuCA;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;AApCF;;AAuCA;EACE,iBAAA;EACA,mCAAA;EACA,qCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,qBAAA;EACA,qBAAA;EACA,6CAAA;AApCF","sourcesContent":[":host {\n  align-items: center;\n  background-color: #0004;\n  display: flex;\n  float: none;\n  margin: 0;\n  padding: 4px;\n  opacity: var(--toolbar-opacity, 1);\n\n  &.menubar-top {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n\n  &.menubar-left {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n\n  &.menubar-right {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n\n  &.menubar-bottom {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n\n.team-button {\n  width: 38px !important;\n  height: 38px !important;\n  padding: 0 !important;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.6);\n  background: rgba(255, 255, 255, 0.08);\n  transition: border-radius 0.15s ease, background 0.15s ease, color 0.15s ease;\n  line-height: 38px;\n  margin: 2px 0;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.18);\n    color: #fff;\n  }\n\n  &.active {\n    background: var(--team-button-active, #5b6eae);\n    color: #fff;\n  }\n\n  // Starred remote place whose device is away: stays put, reads as inert.\n  &.place-offline {\n    opacity: 0.35;\n    cursor: default;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.08);\n      color: rgba(255, 255, 255, 0.6);\n    }\n  }\n\n  .mat-mdc-button-touch-target {\n    width: 38px !important;\n    height: 38px !important;\n  }\n\n  // Horizontal toolbar: space horizontally instead\n  :host(.menubar-top) &,\n  :host(.menubar-bottom) & {\n    margin: 0 2px;\n  }\n}\n\n.team-separator {\n  // Vertical toolbar: horizontal line\n  width: 24px;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.15);\n  margin: 6px 0;\n  flex-shrink: 0;\n\n  // Horizontal toolbar: vertical line\n  :host(.menubar-top) &,\n  :host(.menubar-bottom) & {\n    width: 1px;\n    height: 24px;\n    margin: 0 6px;\n  }\n}\n\n.menubar-logo {\n  object-fit: contain;\n  padding: 4px;\n\n  // Horizontal toolbar: constrain height, let width flow\n  height: 30px;\n  width: auto;\n\n  :host(.menubar-left) &,\n  :host(.menubar-right) & {\n    // Vertical toolbar: constrain width, let height flow\n    height: auto;\n    width: 24px;\n    padding: 4px 0;\n  }\n}\n\n// --- Command palette (Ctrl+K) ---\n\n.command-palette-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding-top: 15vh;\n}\n\n.command-palette {\n  width: min(580px, 92vw);\n  max-height: 62vh;\n  display: flex;\n  flex-direction: column;\n  // Light defaults; dark values below. Was hardcoded dark → unreadable in light\n  // mode (Lais, 2026-09-02).\n  --pal-bg: #ffffff;\n  --pal-fg: rgba(0, 0, 0, 0.87);\n  --pal-muted: rgba(0, 0, 0, 0.5);\n  --pal-faint: rgba(0, 0, 0, 0.38);\n  --pal-line: rgba(0, 0, 0, 0.12);\n  --pal-hover: rgba(0, 0, 0, 0.06);\n  --pal-active: #2e7d32;\n  --pal-pinned: #f9a825;\n  --pal-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);\n  background: var(--pal-bg);\n  color: var(--pal-fg);\n  border: 1px solid var(--pal-line);\n  border-radius: 12px;\n  box-shadow: var(--pal-shadow);\n  overflow: hidden;\n}\n\n.palette-search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--pal-line);\n\n  mat-icon {\n    color: var(--pal-muted);\n  }\n\n  input {\n    flex: 1;\n    background: transparent;\n    border: none;\n    outline: none;\n    color: var(--pal-fg);\n    font-size: 15px;\n\n    &::placeholder {\n      color: var(--pal-faint);\n    }\n  }\n}\n\n.palette-kbd {\n  font-size: 11px;\n  color: var(--pal-muted);\n  border: 1px solid var(--pal-line);\n  border-radius: 4px;\n  padding: 1px 6px;\n}\n\n.palette-list {\n  overflow-y: auto;\n  padding: 4px 0 8px;\n}\n\n.palette-category {\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--pal-faint);\n  padding: 10px 16px 3px;\n}\n\n.palette-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 7px 16px;\n  cursor: pointer;\n  color: var(--pal-fg);\n\n  &.selected {\n    background: var(--pal-hover);\n  }\n\n  .palette-icon {\n    color: var(--pal-muted);\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n\n  .palette-label {\n    flex: 1;\n    font-size: 14px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .palette-active {\n    color: var(--pal-active);\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  .palette-pin {\n    width: 30px !important;\n    height: 30px !important;\n    line-height: 30px !important;\n    padding: 0 !important;\n    opacity: 0.35;\n\n    mat-icon {\n      font-size: 17px;\n      width: 17px;\n      height: 17px;\n    }\n\n    &:hover {\n      opacity: 0.8;\n    }\n\n    &.pinned {\n      opacity: 1;\n      color: var(--pal-pinned);\n    }\n  }\n}\n\n.palette-empty {\n  padding: 18px 16px;\n  color: var(--pal-muted);\n  font-size: 14px;\n}\n\n:host-context(.dark) .command-palette {\n  --pal-bg: #23252b;\n  --pal-fg: rgba(255, 255, 255, 0.92);\n  --pal-muted: rgba(255, 255, 255, 0.5);\n  --pal-faint: rgba(255, 255, 255, 0.38);\n  --pal-line: rgba(255, 255, 255, 0.1);\n  --pal-hover: rgba(255, 255, 255, 0.1);\n  --pal-active: #7bd88f;\n  --pal-pinned: #ffd54f;\n  --pal-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
